import React, { Component } from "react";
import * as BABYLON from "babylonjs";
import "babylonjs-loaders";
import Fab from "@material-ui/core/Fab";
import HelpIcon from "@material-ui/icons/Help";
import PublishIcon from "@material-ui/icons/Publish";

import CustomModal from "../../../components/modal/CustomModal";
import MyCustomModal from "../../../components/modal/MyCustomModal";
import studio from "../assets/FFM.glb";
import BabylonScene from "./Scene";
import type { SceneEventArgs } from "./Scene";
import {
  mediaData,
  FM_ZoneData,
  boothMap,
  liveStreamData,
  FMZone,
  fmZone,
  stairsData,
} from "./Database";
import LoadingScreen from "../../../components/loading-screen/LoadingScreen";
import Home from "../assets/home.png";
import Reticle from "../assets/Reticle.png";
import Waypoint from "../assets/teleport2.png";
import TutorialPopup from "../../../components/tutorial-popup/TutorialPopup";
import Minimap from "../../../components/miniMap/Minimap";
import { db } from "../../../config/Firebase";
import BoothTutorialPopup from '../../../components/tutorial-popup/BoothTutorialPopup';
import VODTab from "../../../components/VOD Tab/VOD";

type ViewerProps = {
  setMinimapData: any,
  phoneno: any
};

const compare = (a, b) => {
  if (a.name < b.name) {
    return -1;
  }
  if (a.name > b.name) {
    return 1;
  }
  return 0;
};

class Viewer extends Component<ViewerProps, {}> {
  constructor(props) {
    super(props);

    this.canvas = "";
    this.engine = "";
    this.scene = "";
    this.camera = "";
    this.light = "";
    this.state = {
      sceneLoadedPercent: 0,
      showLoading: true,
      showModal: false,
      interactables: "",
      url: "",
      currentAnalytics: "",
      chatURL: "",
      videoURL: "",
      showMyModal: false,
      tutorialPop: true,
      boothTutorialPop: false,
      VODtabOpen: false
    };
    this.interactablesData = "";
    this.hotspots = "";
    this.result = "";
    this.reticle = "";
    this.mainModel = "";
    this.oldDataProp = "Home";
    this.boothData = [];
    this.element = null;
    this.currentDocRef = "";
    this.userinfo = "Temp";
    this.userRef = '';
    this.VODbutton = [];
  }

  onSceneMount = (e: SceneEventArgs) => {
    const { canvas, scene, engine } = e;

    this.canvas = canvas;
    this.engine = engine;
    this.scene = scene;
    this.element = document.getElementById("studio");
    this.setupCamera();
    this.setupLights();
    this.loadMediaData();
    this.setupStudio();
    this.transition();

    // this.addObservable();
    console.log(this.props.phoneno.phoneNumber.toString());
    db.collection("users").where("mobileNumber", "==", this.props.phoneno.phoneNumber.toString()).get()
      .then(userSnap => {
        console.log(userSnap.docs[0]);
        this.userinfo = userSnap.docs[0]?.id;
        const userData = userSnap.docs[0]?.data();
        this.userRef = userData?.firstName + " " + userData?.lastName;
      });

    // #region Reticle Setup
    this.reticle = BABYLON.MeshBuilder.CreateDisc("reticle", {
      radius: 0.2,
      sideOrientation: BABYLON.Mesh.DOUBLESIDE,
    });
    this.reticle.isPickable = false;

    const reticleMat = new BABYLON.StandardMaterial("reticleMat", this.scene);
    reticleMat.diffuseTexture = new BABYLON.Texture(Reticle, this.scene);
    reticleMat.unlit = true;
    reticleMat.emissiveTexture = new BABYLON.Texture(Reticle, this.scene);
    reticleMat.opacityTexture = new BABYLON.Texture(Reticle, this.scene);

    this.reticle.material = reticleMat;
    // #endregion

    this.scene.registerBeforeRender(() => {
      if (this.camera.position.y < 5) { this.camera.position.y = 2.5 }
      else { this.camera.position.y = 19.7 }
      this.result = this.raycast();
      if (
        this.result.hit &&
        this.result.pickedMesh.metadata["tag"] === "navigationFloor"
      ) {
        this.reticle.isVisible = true;
        this.reticle.position = new BABYLON.Vector3(
          this.result.pickedPoint.x,
          this.result.pickedPoint.y + 0.1,
          this.result.pickedPoint.z
        );
        this.reticle.rotation.set(Math.PI / 2, this.camera.rotation.y, Math.PI);
      } else {
        this.reticle.isVisible = false;
      }

      if (
        this.result.hit &&
        this.result.pickedMesh &&
        ((this.result.pickedMesh.metadata["tag"] === "Modal" &&
          this.result.pickedMesh.metadata["url"] !== "") ||
          (this.result.pickedMesh.metadata["tag"] === "Pop-Out" &&
            this.result.pickedMesh.metadata["url"] !== "") ||
          this.result.pickedMesh.metadata["tag"] === "wayPoint" ||
          this.result.pickedMesh.metadata["tag"] === "VOD" ||
          this.result.pickedMesh.metadata["tag"] === "groundStairs" ||
          this.result.pickedMesh.metadata["tag"] === "upStairs")
      ) {
        this.element.style.cursor = "pointer";
      } else {
        this.element.style.cursor = "default";
      }
    });

    scene.onPointerObservable.add((pointerInfo) => {
      switch (pointerInfo.type) {
        case BABYLON.PointerEventTypes.POINTERTAP: {
          if (this.result.pickedMesh) {
            switch (this.result.pickedMesh.metadata["tag"]) {
              case "navigationFloor": {
                if (this.reticle.isVisible) {
                  const targetLocation = new BABYLON.Vector3(
                    this.result.pickedPoint.x,
                    this.camera.position.y,
                    this.result.pickedPoint.z
                  );
                  BABYLON.Animation.CreateAndStartAnimation(
                    "Movement",
                    this.camera,
                    "position",
                    50,
                    60,
                    this.camera.position,
                    targetLocation,
                    BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT
                  );
                }
                break;
              }
              case "Modal": {
                if (this.result.pickedMesh.metadata.url != "") {
                  if (this.result.pickedMesh.metadata.name == 'Live') {
                    const values = liveStreamData.get(new Date().getDate().toString());
                    if (values) {
                      this.logAnalytics(this.result.pickedMesh.metadata.name, this.result.pickedMesh.metadata.type, values.videoURL);
                      this.setModalView(values.videoURL, true);
                      this.logLeaderBoard('', this.result.pickedMesh.metadata.mediaSpot, this.result.pickedMesh.metadata.points)
                    }
                  }
                  else {
                    this.logAnalytics(this.result.pickedMesh.metadata.name, this.result.pickedMesh.metadata.type, this.result.pickedMesh.metadata.url);
                    this.setModalView(this.result.pickedMesh.metadata.url, true);
                    this.logLeaderBoard(this.result.pickedMesh.metadata.name, this.result.pickedMesh.metadata.mediaSpot, this.result.pickedMesh.metadata.points)
                  }
                }
                break;
              }
              case "wayPoint": {
                const targetLocation = new BABYLON.Vector3(
                  this.result.pickedMesh.position.x,
                  this.camera.position.y,
                  this.result.pickedMesh.position.z
                );
                const targetRotation = new BABYLON.Vector3(
                  0,
                  this.result.pickedMesh.rotation.y,
                  this.camera.rotation.z
                );
                this.logAnalytics(this.result.pickedMesh.metadata.name, 'Visit', 'None');
                this.animate(targetLocation, targetRotation);
                break;
              }
              case 'Pop-Out': {
                this.logAnalytics(this.result.pickedMesh.metadata.name, this.result.pickedMesh.metadata.type, this.result.pickedMesh.metadata.url);
                this.logLeaderBoard(this.result.pickedMesh.metadata.name, this.result.pickedMesh.metadata.mediaSpot, this.result.pickedMesh.metadata.points)
                window.open(this.result.pickedMesh.metadata.url, 'POP-OUT', "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes")
                break;
              }
              case 'VOD': {
                this.setState({
                  VODtabOpen: true
                })
              }
              case "groundStairs": {
                this.goToFirstFloor();
                break;
              }
              case "upStairs": {
                this.goToHome();
                break;
              }
              default:
                break;
            }
          }
          break;
        }
        default:
          break;
      }
    });

    engine.runRenderLoop(() => {
      if (scene) {
        scene.render();
      }
    });
  };

  setupFMZone = () => {
    FM_ZoneData.forEach((value, key) => {
      const tempObject = Object.keys(FMZone[key]);
      switch (key) {
        case "Partner Testimonials": {
          const playButton = this.getMeshfromMainModel(tempObject[1]);
          if (playButton) {
            playButton.metadata.tag = "Modal";
            playButton.metadata.name = 'FFM_' + key;
            playButton.metadata.type = 'Video';
            playButton.metadata.mediaSpot = "Videos"
            playButton.metadata.points = 100;
            playButton.metadata.url = value["Videos"][0].value;
          }
          break;
        }
        case "What's New?": {
          const wateringHoleMesh = this.getMeshfromMainModel(tempObject[0]);
          const COOvideoMesh = this.getMeshfromMainModel(tempObject[1]);
          const COOPDFMesh = this.getMeshfromMainModel(tempObject[2]);
          const jewelleryCertiMesh = this.getMeshfromMainModel(tempObject[3]);
          const newLogoVideoMesh = this.getMeshfromMainModel(tempObject[4]);
          const aiInteractiveVideoMesh = this.getMeshfromMainModel(
            tempObject[5]
          );
          const aiInteractivePlayVideoMesh = this.getMeshfromMainModel(
            tempObject[6]
          );
          const buildingForeverVideoMesh = this.getMeshfromMainModel(
            tempObject[7]
          );
          const buildingForeverPlayVideoMesh = this.getMeshfromMainModel(
            tempObject[8]
          );
          const buildingForeverPDFMesh = this.getMeshfromMainModel(
            tempObject[9]
          );
          const pursuitPlayVideoMesh = this.getMeshfromMainModel(
            tempObject[10]
          );
          const pursuitVideoMesh = this.getMeshfromMainModel(tempObject[11]);

          if (wateringHoleMesh) {
            wateringHoleMesh.metadata.name = 'FFM_' + key;
            wateringHoleMesh.metadata.tag = "Pop-Out";
            wateringHoleMesh.metadata.mediaSpot = "Web-URL"
            wateringHoleMesh.metadata.points = 100;
            wateringHoleMesh.metadata.type = 'Web-URL';
            wateringHoleMesh.metadata.url = value["Web-URL"][0].value;
          }
          if (COOvideoMesh) {
            COOvideoMesh.metadata.name = 'FFM_' + key;
            COOvideoMesh.metadata.tag = "Modal";
            COOvideoMesh.metadata.mediaSpot = "Videos"
            COOvideoMesh.metadata.points = 100;
            COOvideoMesh.metadata.type = "Videos";
            COOvideoMesh.metadata.url = value["Videos"][0].value;
          }
          if (COOPDFMesh) {
            COOPDFMesh.metadata.name = 'FFM_' + key;
            COOPDFMesh.metadata.tag = "Modal";
            COOPDFMesh.metadata.type = "PDF";
            COOPDFMesh.metadata.mediaSpot = "PDF"
            COOPDFMesh.metadata.points = 100;
            COOPDFMesh.metadata.url = value["PDF"][0].value;
          }
          if (jewelleryCertiMesh) {
            jewelleryCertiMesh.metadata.name = 'FFM_' + key;
            jewelleryCertiMesh.metadata.tag = "Modal";
            jewelleryCertiMesh.metadata.type = "PDF";
            jewelleryCertiMesh.metadata.mediaSpot = "PDF"
            jewelleryCertiMesh.metadata.points = 100;
            jewelleryCertiMesh.metadata.url = value["PDF"][1].value;
          }
          if (newLogoVideoMesh) {
            newLogoVideoMesh.metadata.name = 'FFM_' + key;
            newLogoVideoMesh.metadata.tag = "Modal";
            newLogoVideoMesh.metadata.type = "Videos";
            newLogoVideoMesh.metadata.mediaSpot = "Videos"
            newLogoVideoMesh.metadata.points = 100;
            newLogoVideoMesh.metadata.url = value["Videos"][3].value;
          }
          if (aiInteractivePlayVideoMesh) {
            aiInteractivePlayVideoMesh.metadata.name = 'FFM_' + key;
            aiInteractivePlayVideoMesh.metadata.tag = "Modal";
            aiInteractivePlayVideoMesh.metadata.type = "Videos";
            aiInteractivePlayVideoMesh.metadata.mediaSpot = "Videos"
            aiInteractivePlayVideoMesh.metadata.points = 100;
            aiInteractivePlayVideoMesh.metadata.url = value["Videos"][4].value;
          }
          if (
            buildingForeverPlayVideoMesh &&
            buildingForeverPDFMesh
          ) {
            buildingForeverPlayVideoMesh.metadata.name = 'FFM_' + key;
            buildingForeverPlayVideoMesh.metadata.tag = "Modal";
            buildingForeverPlayVideoMesh.metadata.type = "Videos";
            buildingForeverPlayVideoMesh.metadata.mediaSpot = "Videos"
            buildingForeverPlayVideoMesh.metadata.points = 100;
            buildingForeverPlayVideoMesh.metadata.url =
              value["Videos"][2].value;
            buildingForeverPDFMesh.metadata.name = 'FFM_' + key;
            buildingForeverPDFMesh.metadata.type = "PDF";
            buildingForeverPDFMesh.metadata.tag = "Modal";
            buildingForeverPDFMesh.metadata.mediaSpot = "PDF"
            buildingForeverPDFMesh.metadata.points = 100;
            buildingForeverPDFMesh.metadata.url = value["PDF"][2].value;
          }
          if (pursuitPlayVideoMesh) {
            pursuitPlayVideoMesh.metadata.name = 'FFM_' + key;
            pursuitPlayVideoMesh.metadata.tag = "Modal";
            pursuitPlayVideoMesh.metadata.type = "Videos";
            pursuitPlayVideoMesh.metadata.mediaSpot = "Videos"
            pursuitPlayVideoMesh.metadata.points = 100;
            pursuitPlayVideoMesh.metadata.url = value["Videos"][1].value;
          }

          break;
        }
        case "Yash Innovation": {
          const yashInnovationPlayMesh = this.getMeshfromMainModel(
            tempObject[0]
          );
          const yashInnovationVideoMesh = this.getMeshfromMainModel(
            tempObject[1]
          );
          if (yashInnovationPlayMesh) {
            yashInnovationPlayMesh.metadata.name = 'FFM_' + key;
            yashInnovationPlayMesh.metadata.tag = "Modal";
            yashInnovationPlayMesh.metadata.type = "Videos";
            yashInnovationPlayMesh.metadata.mediaSpot = "Videos"
            yashInnovationPlayMesh.metadata.points = 100;
            yashInnovationPlayMesh.metadata.url = value["Videos"][0].value;
          }
          break;
        }
        case "Brand Corner": {
          const brandEntry1VideoMesh = this.getMeshfromMainModel(tempObject[0]);
          const brandEntry1PlayMesh = this.getMeshfromMainModel(tempObject[1]);
          const brandEntry2VideoMesh = this.getMeshfromMainModel(tempObject[2]);
          const brandEntry2PlayMesh = this.getMeshfromMainModel(tempObject[3]);
          if (brandEntry1PlayMesh) {
            brandEntry1PlayMesh.metadata.name = 'FFM_' + key;
            brandEntry1PlayMesh.metadata.tag = "Modal";
            brandEntry1PlayMesh.metadata.type = "Videos";
            brandEntry1PlayMesh.metadata.mediaSpot = "Videos"
            brandEntry1PlayMesh.metadata.points = 100;
            brandEntry1PlayMesh.metadata.url = value["Videos"][0].value;
          }
          if (brandEntry2PlayMesh) {
            brandEntry2PlayMesh.metadata.name = 'FFM_' + key;
            brandEntry2PlayMesh.metadata.tag = "Modal";
            brandEntry2PlayMesh.metadata.type = "Videos";
            brandEntry2PlayMesh.metadata.mediaSpot = "Videos"
            brandEntry2PlayMesh.metadata.points = 100;
            brandEntry2PlayMesh.metadata.url = value["Videos"][1].value;
          }
          break;
        }
        case "Consumer Marketing": {
          const consumerMarketingVideoMesh = this.getMeshfromMainModel(
            tempObject[0]
          );
          const consumerMarketingPlayMesh = this.getMeshfromMainModel(
            tempObject[1]
          );
          if (consumerMarketingPlayMesh) {
            consumerMarketingPlayMesh.metadata.name = 'FFM_' + key;
            consumerMarketingPlayMesh.metadata.tag = "Modal";
            consumerMarketingPlayMesh.metadata.type = "Videos";
            consumerMarketingPlayMesh.metadata.mediaSpot = "Videos"
            consumerMarketingPlayMesh.metadata.points = 100;
            consumerMarketingPlayMesh.metadata.url = value["Video"][0].value;
          }
          break;
        }
        case "Virtual Showrooms": {
          const foreverbooth = this.getMeshfromMainModel(tempObject[0]);
          const Obsesbooth = this.getMeshfromMainModel(tempObject[1]);
          if (foreverbooth) {
            foreverbooth.metadata.name = 'FFM_' + key;
            foreverbooth.metadata.tag = "Modal";
            foreverbooth.metadata.type = "Web-URL";
            foreverbooth.metadata.mediaSpot = "Web-URL"
            foreverbooth.metadata.points = 100;
            foreverbooth.metadata.url = value["Web-URL"][0].value;
          }
          if (Obsesbooth) {
            Obsesbooth.metadata.name = 'FFM_' + key;
            Obsesbooth.metadata.tag = "Modal";
            Obsesbooth.metadata.type = "Web-URL";
            Obsesbooth.metadata.mediaSpot = "Web-URL"
            Obsesbooth.metadata.points = 100;
            Obsesbooth.metadata.url = value["Web-URL"][1].value;
          }
          break;
        }
        case "Designs & Collections": {
          const trendsurl = this.getMeshfromMainModel(tempObject[0]);
          const trendsVideo = this.getMeshfromMainModel(tempObject[1]);
          const trendsVideoPlay = this.getMeshfromMainModel(tempObject[2]);
          const trendsPDF1 = this.getMeshfromMainModel(tempObject[3]);
          const trendsPDF2 = this.getMeshfromMainModel(tempObject[4]);
          if (trendsurl) {
            trendsurl.metadata.name = 'FFM_' + key;
            trendsurl.metadata.tag = "Modal";
            trendsurl.metadata.type = "Web-URL";
            trendsurl.metadata.mediaSpot = "Web-URL"
            trendsurl.metadata.points = 100;
            trendsurl.metadata.url = value["Web-URL"][0].value;
          }
          if (trendsVideoPlay) {
            trendsVideoPlay.metadata.name = 'FFM_' + key;
            trendsVideoPlay.metadata.tag = "Modal";
            trendsVideoPlay.metadata.type = "Videos";
            trendsVideoPlay.metadata.mediaSpot = "Videos"
            trendsVideoPlay.metadata.points = 100;
            trendsVideoPlay.metadata.url = value["Videos"][0].value;
          }
          if (trendsPDF1) {
            trendsPDF1.metadata.name = 'FFM_' + key;
            trendsPDF1.metadata.tag = "Modal";
            trendsPDF1.metadata.type = "PDF";
            trendsPDF1.metadata.mediaSpot = "PDF"
            trendsPDF1.metadata.points = 100;
            trendsPDF1.metadata.url = value["PDF"][0].value;
          }
          if (trendsPDF2) {
            trendsPDF2.metadata.name = 'FFM_' + key;
            trendsPDF2.metadata.tag = "Modal";
            trendsPDF2.metadata.type = "PDF";
            trendsPDF2.metadata.mediaSpot = "PDF"
            trendsPDF2.metadata.points = 100;
            trendsPDF2.metadata.url = value["PDF"][1].value;
          }
          break;
        }
        case "Forevermark Training": {
          const trainingPDF = this.getMeshfromMainModel(tempObject[0]);
          const trainingVideo = this.getMeshfromMainModel(tempObject[1]);
          const trainingVideoPlay = this.getMeshfromMainModel(tempObject[2]);
          const trainingurl = this.getMeshfromMainModel(tempObject[3]);
          if (trainingPDF) {
            trainingPDF.metadata.name = 'FFM_' + key;
            trainingPDF.metadata.tag = "Modal";
            trainingPDF.metadata.type = "PDF";
            trainingPDF.metadata.mediaSpot = "PDF"
            trainingPDF.metadata.points = 100;
            trainingPDF.metadata.url = value["PDF"][0].value;
          }
          if (trainingVideoPlay) {
            trainingVideoPlay.metadata.name = 'FFM_' + key;
            trainingVideoPlay.metadata.tag = "Modal";
            trainingVideoPlay.metadata.mediaSpot = "Videos"
            trainingVideoPlay.metadata.points = 100;
            trainingVideoPlay.metadata.type = "Videos";
            trainingVideoPlay.metadata.url = value["Videos"][0].value;
          }
          if (trainingurl) {
            trainingurl.metadata.name = 'FFM_' + key;
            trainingurl.metadata.tag = "Modal";
            trainingurl.metadata.type = "Web-URL";
            trainingurl.metadata.mediaSpot = "Web-URL"
            trainingurl.metadata.points = 100;
            trainingurl.metadata.url = value["Web-URL"][0].value;
          }
          break;
        }
        case "New Campaigns": {
          const cotPDF = this.getMeshfromMainModel(tempObject[0]);
          const cotImagePDF = this.getMeshfromMainModel(tempObject[1]);
          const cotVideoPlay = this.getMeshfromMainModel(tempObject[2]);
          const tsPDF = this.getMeshfromMainModel(tempObject[3]);
          const tsImagePDF = this.getMeshfromMainModel(tempObject[4]);
          const tsVideoPlay = this.getMeshfromMainModel(tempObject[5]);
          const fashionPDF = this.getMeshfromMainModel(tempObject[6]);
          const fashionImagePDF = this.getMeshfromMainModel(tempObject[7]);
          const fashionPlay = this.getMeshfromMainModel(tempObject[8]);
          const ECUrl = this.getMeshfromMainModel(tempObject[9]);

          if (cotPDF) {
            cotPDF.metadata.name = 'FFM_' + key;
            cotPDF.metadata.tag = "Modal";
            cotPDF.metadata.type = "PDF";
            cotPDF.metadata.mediaSpot = "PDF"
            cotPDF.metadata.points = 100;
            cotPDF.metadata.url = value["PDF"][0].value;
          }
          if (cotImagePDF) {
            cotImagePDF.metadata.name = 'FFM_' + key;
            cotImagePDF.metadata.tag = "Modal";
            cotImagePDF.metadata.type = "Web-URL";
            cotImagePDF.metadata.mediaSpot = "Web-URL"
            cotImagePDF.metadata.points = 100;
            cotImagePDF.metadata.url = value["Web-URL"][0].value;
          }
          if (cotVideoPlay) {
            cotVideoPlay.metadata.name = 'FFM_' + key;
            cotVideoPlay.metadata.tag = "Modal";
            cotVideoPlay.metadata.type = "Videos";
            cotVideoPlay.metadata.mediaSpot = "Videos"
            cotVideoPlay.metadata.points = 100;
            cotVideoPlay.metadata.url = value["Videos"][0].value;
          }
          if (tsPDF) {
            tsPDF.metadata.name = 'FFM_' + key;
            tsPDF.metadata.tag = "Modal";
            tsPDF.metadata.type = "PDF";
            tsPDF.metadata.mediaSpot = "PDF"
            tsPDF.metadata.points = 100;
            tsPDF.metadata.url = value["PDF"][1].value;
          }
          if (tsImagePDF) {
            tsImagePDF.metadata.name = 'FFM_' + key;
            tsImagePDF.metadata.tag = "Modal";
            tsImagePDF.metadata.type = "Web-URL";
            tsImagePDF.metadata.mediaSpot = "Web-URL"
            tsImagePDF.metadata.points = 100;
            tsImagePDF.metadata.url = value["Web-URL"][1].value;
          }
          if (tsVideoPlay) {
            tsVideoPlay.metadata.name = 'FFM_' + key;
            tsVideoPlay.metadata.tag = "Modal";
            tsVideoPlay.metadata.type = "Videos";
            tsVideoPlay.metadata.mediaSpot = "Videos"
            tsVideoPlay.metadata.points = 100;
            tsVideoPlay.metadata.url = value["Videos"][1].value;
          }
          if (fashionPDF) {
            fashionPDF.metadata.name = 'FFM_' + key;
            fashionPDF.metadata.tag = "Modal";
            fashionPDF.metadata.type = "PDF";
            fashionPDF.metadata.mediaSpot = "PDF"
            fashionPDF.metadata.points = 100;
            fashionPDF.metadata.url = value["PDF"][2].value;
          }
          if (fashionImagePDF) {
            fashionImagePDF.metadata.name = 'FFM_' + key;
            fashionImagePDF.metadata.tag = "Modal";
            fashionImagePDF.metadata.type = "Web-URL";
            fashionImagePDF.metadata.mediaSpot = "Web-URL"
            fashionImagePDF.metadata.points = 100;
            fashionImagePDF.metadata.url = value["Web-URL"][2].value;
          }
          if (fashionPlay) {
            fashionPlay.metadata.name = 'FFM_' + key;
            fashionPlay.metadata.tag = "Modal";
            fashionPlay.metadata.type = "Videos";
            fashionPlay.metadata.mediaSpot = "Videos"
            fashionPlay.metadata.points = 100;
            fashionPlay.metadata.url = value["Videos"][2].value;
          }
          if (ECUrl) {
            ECUrl.metadata.name = 'FFM_' + key;
            ECUrl.metadata.tag = "Modal";
            ECUrl.metadata.type = "Web-URL";
            ECUrl.metadata.mediaSpot = "Web-URL"
            ECUrl.metadata.points = 100;
            ECUrl.metadata.url = value["Web-URL"][3].value;
          }
          break;
        }
        case "Consumer Insights": {
          const CIPDF = this.getMeshfromMainModel(tempObject[0]);
          if (CIPDF) {
            CIPDF.metadata.name = 'FFM_' + key;
            CIPDF.metadata.tag = "Modal";
            CIPDF.metadata.type = "PDF";
            CIPDF.metadata.mediaSpot = "PDF"
            CIPDF.metadata.points = 100;
            CIPDF.metadata.url = value["PDF"][0].value;
          }
          break;
        }
        case "Gamification": {
          for (let index = 0; index < tempObject.length; index += 1) {
            const element = tempObject[index];
            switch (FMZone[key][element]) {
              case "Game Button": {
                const gameButton = this.getMeshfromMainModel(element);
                if (gameButton) {
                  gameButton.metadata.name = 'FFM_' + key;
                  gameButton.metadata.tag = "Modal";
                  gameButton.metadata.type = "Web-URL";
                  gameButton.metadata.mediaSpot = "Web-URL"
                  gameButton.metadata.points = 100;
                  gameButton.metadata.url = value["Web-URL"][0].value;
                }
                break;
              }
            }
          }
          break;
        }
        case "Grand Launch": {
          for (let index = 0; index < tempObject.length; index += 1) {
            const element = tempObject[index];
            switch (FMZone[key][element]) {
              case "Play": {
                const Play = this.getMeshfromMainModel(element);
                Play.metadata.name = 'FFM_' + key;
                Play.metadata.type = "Videos";
                Play.metadata.mediaSpot = "Videos"
                Play.metadata.points = 100;
                Play.metadata.tag = Play._children[0].metadata.tag = "Modal";
                Play.metadata.url = Play._children[0].metadata.url =
                  value["Videos"][0].value;
                break;
              }
              case "URL": {
                const gameButton = this.getMeshfromMainModel(element);
                if (gameButton) {
                  gameButton.metadata.tag =
                    gameButton._children[0].metadata.tag = "Modal";
                  gameButton.metadata.type = "Web-URL";
                  gameButton.metadata.mediaSpot = "Web-URL"
                  gameButton.metadata.points = 100;
                  gameButton.metadata.name = 'FFM_' + key;
                  gameButton.metadata.url =
                    gameButton._children[0].metadata.url =
                    value["Web-URL"][0].value;
                }
                break;
              }
              case "PDF": {
                const PDF = this.getMeshfromMainModel(element);
                if (PDF) {
                  PDF.metadata.tag = PDF._children[0].metadata.tag = "Modal";
                  PDF.metadata.name = 'FFM_' + key;
                  PDF.metadata.mediaSpot = "PDF"
                  PDF.metadata.points = 100;
                  PDF.metadata.type = "PDF";
                  PDF.metadata.url = PDF._children[0].metadata.url =
                    value["PDF"][0].value;
                }
                break;
              }
            }
          }
          break;
        }
        case "Visual Search Tool": {
          const VSTUrl = this.getMeshfromMainModel(tempObject[0]);
          const VSTVideoPlay = this.getMeshfromMainModel(tempObject[1]);
          const VSTPDF = this.getMeshfromMainModel(tempObject[2]);
          if (VSTPDF) {
            VSTPDF.metadata.name = 'FFM_' + key;
            VSTPDF.metadata.tag = "Modal";
            VSTPDF.metadata.type = "PDF";
            VSTPDF.metadata.mediaSpot = "PDF"
            VSTPDF.metadata.points = 100;
            VSTPDF.metadata.url = value["PDF"][0].value;
          }
          if (VSTVideoPlay) {
            VSTVideoPlay.metadata.name = 'FFM_' + key;
            VSTVideoPlay.metadata.tag = "Modal";
            VSTVideoPlay.metadata.type = "Videos";
            VSTVideoPlay.metadata.mediaSpot = "Videos"
            VSTVideoPlay.metadata.points = 100;
            VSTVideoPlay.metadata.url = value["Videos"][0].value;
          }
          if (VSTUrl) {
            VSTUrl.metadata.name = 'FFM_' + key;
            VSTUrl.metadata.tag = "Modal";
            VSTUrl.metadata.type = "Web-URL";
            VSTUrl.metadata.mediaSpot = "Web-URL"
            VSTUrl.metadata.points = 100;
            VSTUrl.metadata.url = value["Web-URL"][0].value;
          }
          break;
        }
        case "Team Profile": {
          const teamProfilePDF = this.getMeshfromMainModel(tempObject[0]);
          if (teamProfilePDF) {
            teamProfilePDF.metadata.name = 'FFM_' + key;
            teamProfilePDF.metadata.type = "PDF";
            teamProfilePDF.metadata.tag = "Modal";
            teamProfilePDF.metadata.mediaSpot = "PDF"
            teamProfilePDF.metadata.points = 100;
            teamProfilePDF.metadata.url = value["PDF"][0].value;
            break;
          }
        }
      }
    });
  };

  setupCamera = () => {
    this.camera = new BABYLON.FreeCamera(
      "camera1",
      new BABYLON.Vector3(0.34, 2.6, -92),
      this.scene
    );
    this.camera.setTarget(BABYLON.Vector3.Zero());
    this.camera.attachControl(this.canvas, true);
    this.camera.rotation = new BABYLON.Vector3(-0.05235988, 0.02, 0);
    // this.camera.inputs.remove(this.camera.inputs.attached.keyboard);

    // document.onkeypress = (e)=>{
    //   if(e.code === "KeyD"){ this.camera.position.addInPlace(this.camera.getDirection(BABYLON.Vector3.Right())); }
    //   if(e.code === "KeyA"){ this.camera.position.addInPlace(this.camera.getDirection(BABYLON.Vector3.Left())); }
    //   if(e.code === "KeyW"){
    //     this.camera.position.addInPlace(this.camera.getDirection(BABYLON.Vector3.Forward()));
    //   }
    //   if(e.code === "KeyS"){
    //     this.camera.position.addInPlace(this.camera.getDirection(BABYLON.Vector3.Backward()));
    //   }
    // };

    const gl = new BABYLON.GlowLayer("glow", this.scene);
    gl.intensity = 0.25;
    gl.blurKernelSize = 16;
  };

  setupLights = () => {
    const light = new BABYLON.HemisphericLight(
      "light1",
      new BABYLON.Vector3(0, 0, 0),
      this.scene
    );
    light.intensity = 0.5;
    const cubeTex = new BABYLON.CubeTexture(
      "https://storage.googleapis.com/forevermarkforum2021.appspot.com/skybox/forevermark",
      this.scene
    );
    cubeTex.rotationY = 4.3;
    this.scene.createDefaultSkybox(cubeTex, true, 1000, 0, false);
    this.scene.environmentTexture = cubeTex;
    this.scene.environmentIntensity = 0.5;

    const light2 = new BABYLON.DirectionalLight(
      "light2",
      new BABYLON.Vector3(0, -1, 0),
      this.scene
    );
    light2.intensity = 13;
  };

  setTextureonScreen = (screenName, screenObject) => {
    const thumbnailTexture = mediaData.get(screenName);
    const screenMat = new BABYLON.StandardMaterial("screenMat", this.scene);
    screenObject.material = screenMat;
    screenObject.material.emissiveTexture = thumbnailTexture.thumbnail;
    screenObject.material.diffuseColor = new BABYLON.Color3.Black();
    screenObject.material.specularColor = new BABYLON.Color3.Black();
  };

  setVideoTextureonScreen = (screenName, screenObject) => {
    const videoTextureURL = mediaData.get(screenName).Video_url;
    const videoTexture = new BABYLON.VideoTexture(
      "texture",
      videoTextureURL,
      this.scene,
      false,
      true
    );
    videoTexture.video.muted = true;
    videoTexture.video.play();
    const screenMat = new BABYLON.StandardMaterial("screenMat", this.scene);
    screenMat.emissiveTexture = videoTexture;
    screenMat.diffuseColor = new BABYLON.Color3.Black();
    screenMat.specularColor = new BABYLON.Color3.Black();
    screenObject.material = screenMat;
  };

  setupStudio = () => {
    const loadingCalc = (data) => {
      const { loaded } = data;
      const sceneLoadedPercent = ((loaded * 100) / 27184840).toFixed();
      this.setState((prevState) => ({
        ...prevState,
        sceneLoadedPercent,
        showLoading: true,
      }));

      this.scene.executeWhenReady(() => {
        this.setState((prevState) => ({
          ...prevState,
          sceneLoadedPercent: 100,
          showLoading: false,
        }));
      });
    };

    // BABYLON.DracoCompression.Configuration = {
    //   decoder: {
    //     wasmUrl:
    //       "https://www.gstatic.com/draco/versioned/decoders/1.4.1/draco_decoder.js",
    //     wasmBinaryUrl:
    //       "https://www.gstatic.com/draco/versioned/decoders/1.4.1/draco_decoder.wasm",
    //     fallbackUrl:
    //       "https://www.gstatic.com/draco/versioned/decoders/1.4.1/draco_wasm_wrapper.js",
    //   },
    // };
    BABYLON.SceneLoader.ImportMeshAsync(
      "",
      studio,
      "",
      this.scene,
      loadingCalc
    ).then((studio) => {
      // this.scene.materials.forEach((mat) => (mat.unlit = true));

      const { meshes } = studio;
      this.mainModel = meshes;

      const floor = this.scene.getMaterialByName("Floor");
      floor.environmentIntensity = 0.8;
      floor.directIntensity = 0.25;

      this.camera.speed = 0.25;
      this.camera.ellipsoid = new BABYLON.Vector3(0.5, 0.5, 0.5);
      this.scene.collisionsEnabled = true;
      this.camera.checkCollisions = true;

      for (let index = 0; index < meshes[0]._children.length; index += 1) {
        const element = meshes[0]._children[index];
        //collision on
        element.checkCollisions = true;
        if (element.name === "893672" || element.name === "Audi Video") {
          this.setVideoTextureonScreen("Main Screen", element);
        } else if (element.name === "Audi") {
          this.setTextureonScreen("Audi Screen", element);
        }
        else if (element.name === 'Plane.001') {
          element.metadata.tag = "Modal";
          element.metadata.name = 'Live';
          element.metadata.mediaSpot = 'keynote';
          element.metadata.type = 'Videos';
          element.metadata.points = 100;
        }
        else if (element.name === 'Plane.002') {
          element.metadata.tag = "VOD";
        } else if (element.name === "ground" || element.name === "Booth Base") {
          element.metadata.tag = "navigationFloor";
        }
      }

      this.setupBooths();
      this.setupFMZone();

      Object.keys(fmZone).forEach((zone) => {
        const fmZoneWp = this.makeWaypoint(
          fmZone[zone].Transform.name,
          fmZone[zone].Transform.posX,
          fmZone[zone].Transform.posY,
          fmZone[zone].Transform.posZ,
          fmZone[zone].Transform.rotX,
          fmZone[zone].Transform.rotY,
          fmZone[zone].Transform.rotZ
        );
        fmZoneWp.metadata = { tag: "wayPoint", name: 'FM-Zone' };
      });

      Object.keys(stairsData).forEach((stairs) => {
        const stairsWp = this.makeWaypoint(
          stairsData[stairs].Transform.name,
          stairsData[stairs].Transform.posX,
          stairsData[stairs].Transform.posY,
          stairsData[stairs].Transform.posZ,
          stairsData[stairs].Transform.rotX,
          stairsData[stairs].Transform.rotY,
          stairsData[stairs].Transform.rotZ
        );
        if (stairs === "groundStair1" || stairs === "groundStair2") {
          stairsWp.metadata = { tag: "groundStairs", name: "Audi" };
        } else {
          stairsWp.metadata = { tag: "upStairs", name: "Ground Floor" };
        }
      });
    });
  };

  getMeshfromMainModel = (name) => {
    for (
      let index = 0;
      index < this.mainModel[0]._children.length;
      index += 1
    ) {
      const element = this.mainModel[0]._children[index];
      if (element.name === name) {
        return element;
      }
    }
    return null;
  };

  setupBooths = () => {
    // Putting Videos on Screen
    Object.keys(boothMap).forEach((booth) => {
      const screen = Object.keys(boothMap[booth].boothInfo)[0];
      const playButton = Object.keys(boothMap[booth].boothInfo)[1];
      const chatButton = Object.keys(boothMap[booth].boothInfo)[2];
      const urlButton = Object.keys(boothMap[booth].boothInfo)[3];
      const broucherButton = Object.keys(boothMap[booth].boothInfo)[4];
      const sec_TV = Object.keys(boothMap[booth].boothInfo)[5];
      const logo = Object.keys(boothMap[booth].boothInfo)[6];
      const pamphlet = Object.keys(boothMap[booth].boothInfo)[7];
      const boothname = mediaData.get(booth).name;

      const wayPoint = this.makeWaypoint(
        boothMap[booth].Transform.name,
        boothMap[booth].Transform.posX,
        boothMap[booth].Transform.posY,
        boothMap[booth].Transform.posZ,
        boothMap[booth].Transform.rotX,
        boothMap[booth].Transform.rotY,
        boothMap[booth].Transform.rotZ
      );
      wayPoint.metadata = { tag: "wayPoint", name: boothname };
      const element = this.getMeshfromMainModel(screen);
      const buttonElement = this.getMeshfromMainModel(playButton);
      const chatElement = this.getMeshfromMainModel(chatButton);
      const urlElement = this.getMeshfromMainModel(urlButton);
      const broucherElement = this.getMeshfromMainModel(broucherButton);
      const sec_TVElement = this.getMeshfromMainModel(sec_TV);
      const logoElement = this.getMeshfromMainModel(logo);
      const pamphletElement = this.getMeshfromMainModel(pamphlet);

      if (element) {
        this.setTextureonScreen(boothMap[booth].boothInfo[screen], element);
      }
      if (buttonElement) {
        buttonElement.metadata.tag = "Modal";
        buttonElement.metadata.type = "Videos";
        buttonElement.metadata.mediaSpot = "Videos"
        buttonElement.metadata.points = 100;
        buttonElement.metadata.name = boothname;
        buttonElement.metadata.url = mediaData.get(
          boothMap[booth].boothInfo[screen]
        ).Video_url;
      }
      if (chatElement) {
        chatElement.metadata.tag = "Modal";
        chatElement.metadata.mediaSpot = "Chat"
        chatElement.metadata.type = "Chat";
        chatElement.metadata.points = 100;
        chatElement.metadata.name = boothname;
        chatElement.metadata.url = mediaData.get(
          boothMap[booth].boothInfo[screen]
        ).chaturl;
      }
      if (urlElement) {
        urlElement.metadata.tag = "Modal";
        urlElement.metadata.mediaSpot = "Web-URL"
        urlElement.metadata.type = "Web-URL";
        urlElement.metadata.points = 100;
        urlElement.metadata.name = boothname;
        urlElement.metadata.url = mediaData.get(
          boothMap[booth].boothInfo[screen]
        ).site_URL;
      }
      if (broucherElement) {
        broucherElement.metadata.tag = "Modal";
        broucherElement.metadata.type = "PDF";
        broucherElement.metadata.mediaSpot = "PDF"
        broucherElement.metadata.points = 100;
        broucherElement.metadata.name = boothname;
        broucherElement.metadata.url = mediaData.get(
          boothMap[booth].boothInfo[screen]
        ).PDF_Url;
      }
      if (sec_TVElement) {
        const newMat = new BABYLON.StandardMaterial("screenMat", this.scene);
        newMat.useAlphaFromDiffuseTexture = true;
        newMat.diffuseTexture = mediaData.get(
          boothMap[booth].boothInfo[screen]
        )[["Sec_Tv"]];
        newMat.diffuseTexture.hasAlpha = true;
        sec_TVElement.material = newMat;
      }
      if (logoElement) {
        const newMat = new BABYLON.StandardMaterial("screenMat", this.scene);
        newMat.diffuseTexture = mediaData.get(
          boothMap[booth].boothInfo[screen]
        )[["logo"]];
        if (newMat.diffuseTexture) {
          newMat.useAlphaFromDiffuseTexture = true;
          newMat.diffuseTexture.hasAlpha = true;
        }
        logoElement.material = newMat;
      }
      if (pamphletElement) {
        pamphletElement.metadata.tag = "Modal";
        pamphletElement.metadata.name = boothname;
        pamphletElement.metadata.mediaSpot = "Web-URL"
        pamphletElement.metadata.points = 100;
        pamphletElement.metadata.type = "Web-URL";
        pamphletElement.metadata.url = mediaData.get(
          boothMap[booth].boothInfo[screen]
        ).pamplate_Url;
      }
      if (sec_TVElement) {
        const newMat = new BABYLON.StandardMaterial("screenMat", this.scene);
        newMat.useAlphaFromDiffuseTexture = true;
        newMat.diffuseTexture = mediaData.get(
          boothMap[booth].boothInfo[screen]
        )[["Sec_Tv"]];
        newMat.diffuseTexture.hasAlpha = true;
        sec_TVElement.material = newMat;
      }
      if (logoElement) {
        const newMat = new BABYLON.StandardMaterial("screenMat", this.scene);
        newMat.diffuseTexture = mediaData.get(
          boothMap[booth].boothInfo[screen]
        )[["logo"]];
        if (newMat.diffuseTexture) {
          newMat.useAlphaFromDiffuseTexture = true;
          newMat.diffuseTexture.hasAlpha = true;
        }
        logoElement.material = newMat;
      }
      if (pamphletElement) {
        pamphletElement.metadata.tag = "Modal";
        pamphletElement.metadata.type = "Web-URL";
        pamphletElement.metadata.url = mediaData.get(
          boothMap[booth].boothInfo[screen]
        ).pamplate_Url;
      }
    });
  };

  setModalView = (Url, show) => {
    this.setState(() => ({
      url: Url,
      showModal: show,
    }));
  };

  setMyModalView = (chatURL, videoURL, show) => {
    this.setState(() => ({
      chatURL: chatURL,
      videoURL: videoURL,
      showMyModal: show,
    }));
  };

  transition = () => {
    this.element = document.getElementById("transition");
    this.element.style.height = "100vh";
    this.element.style.width = "100%";
    this.element.style = "Background: Black";
  };

  fade = (element, duration) => {
    (function increment(value = 0) {
      element.style.opacity = String(value);
      if (element.style.opacity !== "1") {
        setTimeout(() => {
          increment(value + 0.1);
        }, duration / 10);
      }
    })();
  };

  // function to fetch data from database and load it based on URL
  loadMediaData = () => {
    db.collection("boothdata")
      .get()
      .then(async (doc) => {
        doc.docs.map((data) => {
          const fetchedData = data.data();
          const thumbnail = new BABYLON.Texture(
            fetchedData["thumbnail-URL"],
            this.scene,
            false,
            false
          );
          let Sec_Tv_Texture = null;
          let Logo_Texture = null;

          if (fetchedData["Sec_TV"] != "") {
            Sec_Tv_Texture = new BABYLON.Texture(
              fetchedData["Sec_TV"],
              this.scene,
              false,
              false
            );
          }
          if (fetchedData["logo"] != "") {
            Logo_Texture = new BABYLON.Texture(
              fetchedData["logo"],
              this.scene,
              false,
              false
            );
          }

          const tempObject = {
            name: fetchedData.name,
            thumbnail: thumbnail,
            Video_url: fetchedData.asset_url,
            PDF_Url: fetchedData.PDF_Url,
            site_URL: fetchedData.site_URL,
            pamplate_Url: fetchedData.pamplate_Url,
            Sec_Tv: Sec_Tv_Texture,
            logo: Logo_Texture,
            chaturl: fetchedData.chaturl,
          };

          if (tempObject.name !== "") {
            this.boothData.push({ id: data.id, name: tempObject.name });
          }

          this.props.setMinimapData(this.boothData.sort(compare));
          mediaData.set(data.id, { ...tempObject });
          return null;
        });
      });
    db.collection("FM-Zone Data")
      .get()
      .then(async (doc) => {
        doc.docs.map((data) => {
          const fetchedData = data.data();
          FM_ZoneData.set(data.id, { ...fetchedData });
        });
      });
    db.collection('liveStreamingData').onSnapshot((snapshot) => {
      snapshot.docs.map((data) => {
        const fetchedData = data.data();
        liveStreamData.set(data.id, { ...fetchedData });
      });
      this.checkTime();
    })

    db.collection("VOD Data")
      .get()
      .then(async (doc) => {
        doc.docs.map((data) => {
          const fetchedData = data.data();
          this.VODbutton.push({ ...fetchedData })
        });
      });
  };

  raycast = () => {
    const hit = this.scene.pick(this.scene.pointerX, this.scene.pointerY);
    return hit;
  };

  goToHome = () => {
    this.logAnalytics('Ground Floor', 'Visit', 'None');
    const toRotation = new BABYLON.Vector3(0, 0, 0);
    const toPosition = new BABYLON.Vector3(0.34, 2.5, -92);
    const currentPosition = this.camera.position;
    if (currentPosition.y > 10 || currentPosition !== toPosition) {
      this.animate(toPosition, toRotation);
    }
  };

  goToFirstFloor = () => {
    this.logAnalytics('Audi', 'Visit', 'None');
    const toRot = new BABYLON.Vector3(0, 0, 0);
    const toPos = new BABYLON.Vector3(0, 19.7, 5);
    const currentPosition = this.camera.position.y;
    if (currentPosition < 10) {
      this.animate(toPos, toRot);
    }
  };

  makeWaypoint = (name, x, y, z, rotX, rotY, rotZ) => {
    const wayPoint = BABYLON.MeshBuilder.CreateDisc(name, {
      radius: 0.5,
      sideOrientation: BABYLON.Mesh.DOUBLESIDE,
    });
    wayPoint.position = new BABYLON.Vector3(x, y, z);
    wayPoint.rotation = new BABYLON.Vector3(rotX, rotY, rotZ);

    const wpMat = new BABYLON.StandardMaterial("wpMat", this.scene);
    wpMat.diffuseTexture = new BABYLON.Texture(Waypoint, this.scene);
    wpMat.unlit = true;
    wpMat.emissiveTexture = new BABYLON.Texture(Waypoint, this.scene);
    wpMat.opacityTexture = new BABYLON.Texture(Waypoint, this.scene);

    wayPoint.material = wpMat;
    return wayPoint;
  };

  moveToWayPoint = (name) => {
    let transform = "";
    if (name === "fmWaypoint1") {
      this.logAnalytics('FM-Zone', 'Visit', 'None');
      transform = fmZone["Entry 1"].Transform;
    } else {
      this.logAnalytics(mediaData.get(name).name, 'Visit', 'None');
      transform = boothMap[name].Transform;
    }

    this.animate(
      new BABYLON.Vector3(transform.posX, transform.posY + 1.5, transform.posZ),
      new BABYLON.Vector3(0, transform.rotY, this.camera.rotation.z)
    );
  };

  animate = (targetLocation, targetRotation) => {
    this.fade(this.element);
    this.camera.position = targetLocation;
    this.camera.rotation = targetRotation;
  };

  checkTime = () => {
    const currentDay = new Date().getDate();
    const currentTime = new Date().getTime();
    const values = liveStreamData.get(currentDay.toString());

    const startTime = values?.startTime.toMillis();
    const endTime = values?.endTime.toMillis();

    if (currentTime > endTime) {
      return;
    }
    if (currentTime > startTime && currentTime < endTime) {
      this.setMyModalView(values.chatURL, values.videoURL, true);
      setTimeout(() => {
        this.setMyModalView('', '', false);
      }, endTime - currentTime);
    }
    if (currentTime < startTime) {
      setTimeout(() => {
        this.setMyModalView(values.chatURL, values.videoURL, true);
      }, startTime - currentTime);
    }
  }

  logAnalytics = (areaName, interactionType, Url) => {
    db.collection("analytics").add({
      'startedAt': Date.now(),
      'areaName': areaName,
      'eventType': 'interaction',
      'interactionType': interactionType,
      'interactionLink': Url,
      'userName': this.userRef,
      'endedAt': ''
    }).then((docref) => {
      this.currentDocRef = docref;
    })
      .catch((error) => {
        console.error("Error adding document: ", error);
      });
  };

  finishAnalytics = () => {
    db.collection("analytics").doc(this.currentDocRef.id).update({
      'endedAt': Date.now(),
    }).then((docref) => {
      console.log(docref);
    });
  };

  logLeaderBoard = (areaName, mediaSpotName, points) => {
    let fieldName = "";
    if (mediaSpotName == "keynote") {
      fieldName = mediaSpotName;
    } else {
      fieldName = areaName + "_" + mediaSpotName;
    }

    db.collection("leaderBoardData")
      .doc(this.userinfo)
      .set({
        [`${fieldName}`]: points,
      }, { merge: true })
      .catch((error) => {
        console.error("Error adding document: ", error);
      });
  };

  render() {
    const { sceneLoadedPercent, showLoading, url, showModal } = this.state;

    return (
      <>
        <VODTab open={this.state.VODtabOpen} handleClose={() => {
          this.setState({
            VODtabOpen: false
          })
        }} buttonsArray={this.VODbutton} onClick={(url) => {
          this.setModalView(url, true)
          this.logAnalytics('Audi', 'Button', url)
          this.setState({
            VODtabOpen: false
          })
        }
        } />
        <TutorialPopup open={this.state.tutorialPop} handleClose={() => {
          this.setState(() => ({
            tutorialPop: false,
            boothTutorialPop: true
          }))
        }} />

        <BoothTutorialPopup open={this.state.boothTutorialPop} handleClose={() => {
          this.setState(() => ({
            boothTutorialPop: false
          }))
        }} />
        <CustomModal
          url={url}
          show={showModal}
          onHide={() => {
            this.setModalView("", false);
            this.finishAnalytics();
          }}
        />
        <MyCustomModal
          videoURL={this.state.videoURL}
          chatURL={this.state.chatURL}
          show={this.state.showMyModal}
          onHide={() => {
            this.setMyModalView("", "", false);
            // this.finishAnalytics();
          }}
        />
        <BabylonScene onSceneMount={this.onSceneMount} />
        <LoadingScreen show={showLoading} loadedPercent={sceneLoadedPercent} />
      </>
    );
  }
}
export default Viewer;
